import { useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { PqrCallInfo } from '../../../../../../shared/types/modules/pqr';
import { PqrCallInfoProps } from './props';

export const usePqrCallInfo = ({
    data,
    onChangeData,
    onChangeFormik,
}: PqrCallInfoProps) => {
    const onSubmit = (data: PqrCallInfo) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('callId', data?.callId || '');
    }, [data]);

    return {
        formik,
    };
};
